import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncNumberFormattingFlagEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-number-currency-formatting-changeboarding-modal" */ './NumberFormattingFlag'
			),
	),
	getPreloadProps: () => ({}),
});
